var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['main -flex-center-all -full-width -full-height', _vm.moduleClasses]},[_c('div',{staticClass:"img-wrapper -top",style:([_vm.imgStyles])})])}
var staticRenderFns = []

export { render, staticRenderFns }